import { render } from "./participants.vue?vue&type=template&id=1ed8e62a&scoped=true"
import script from "./participants.vue?vue&type=script&lang=js"
export * from "./participants.vue?vue&type=script&lang=js"

import "./participants.vue?vue&type=style&index=0&id=1ed8e62a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ed8e62a"]])

export default __exports__